import { createSlice } from '@reduxjs/toolkit';

export const exerciseSlice = createSlice({
    name: 'exercise',
    initialState: {
        data: null,
    },
    reducers: {
        setExercise: (state, action) => {
            state.data = action.payload
        },
    },
})

// Action creators are generated for each case reducer function
export const { setExercise } = exerciseSlice.actions

export default exerciseSlice.reducer